import { ButtonSubmit } from '~/components/Buttons/ButtonSubmit';
import { InputCityAutocomplete } from '~/components/InputCityAutocomplete';
import Select, { Option } from '~/components/Select';
import { Select2DeliveryService } from '~/components/Select2DeliveryService';
import { InputBase } from '~/InputBase';
import { LogisticEntry } from './LogisticList';

export const LogisticForm = {
	name: 'LogisticForm',
	functional: true,
	props: {
		item: LogisticEntry,
		deliveryServices: {
			type: Array,
			default: () => [],
		},
		cargoTypes: {
			type: Array,
			default: () => [],
		},
	},
	render(h, { props }) {
		return (
			<form method="post">
				<input type="hidden" name="form" domPropsValue="logistic" />
				{ props.item?.id ? (
					<input type="hidden" name="LOGISTIC_ID" domPropsValue={ props.item.id } />
				) : null }
				<div class="mb-6 grid grid-cols-2 gap-4">
					<InputCityAutocomplete
						label="Город отправления"
						name="CITY_START"
						defaultValue={ props.item?.startPoint }
						required={ true }
					/>
					<InputCityAutocomplete
						label="Город прибытия"
						name="CITY_FINISH"
						defaultValue={ props.item?.destination }
						required={ true }
					/>
				</div>
				<label class="input-block mb-6">
					<Select class="input-block__input" name="CARGO_TYPE" defaultValue={ props.item?.type }>
						{ props.cargoTypes.map((type) => (
							<Option value={ type.id }>
								{ type.name }
							</Option>
						)) }
					</Select>
					<div class="label input-block__label">
						Характер груза
					</div>
				</label>
				<Select2DeliveryService
					class="mb-6"
					name="TRANSPORT_ID"
					label="Транспортная кампания"
					value={ props.item?.service }
					required={ true }
				/>
				<InputBase
					class="mb-6"
					label="Трек-номер"
					name="TRACK"
					defaultValue={ props.item?.trackingNumber }
					required={ true }
				/>
				<InputBase
					class="mb-6"
					label="Сумма отправления"
					name="PRICE"
					defaultValue={ props.item?.price }
					required={ true }
				/>
				<ButtonSubmit />
			</form>
		);
	},
}
